/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const bicycle_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20.25 8.849c.817 0 1.5-.693 1.5-1.522 0-.829-.683-1.521-1.5-1.521h-3.408c-.517 0-.881.552-.7 1.033l1.05 2.772m2.308 6.085-2.307-6.085M10.5 5.806l-3.005-.762M5.35 4.5l2.144.544M4.5 15.696l6.04-2.896m0 0L7.495 5.043M10.54 12.8l6.653-3.189M8.25 15.696c0 2.1-1.679 3.804-3.75 3.804-2.071 0-3.75-1.703-3.75-3.804 0-2.1 1.679-3.804 3.75-3.804 2.071 0 3.75 1.703 3.75 3.804Zm15 0c0 2.1-1.679 3.804-3.75 3.804-2.071 0-3.75-1.703-3.75-3.804 0-2.1 1.679-3.804 3.75-3.804 2.071 0 3.75 1.703 3.75 3.804Z"
    />
  </svg>
)
export default bicycle_medium
